import clsx from 'clsx'
import type { FunctionComponent } from 'react'
import { InternalLink } from '../../const/Links'
import { BANNER_INDEX } from '../../const/digitContants'
import { useTranslate } from '../../contexts/TranslationContext'
import type { ItemResult } from '../../data/ItemFragment'
import { useAuth } from '../../user/UserContext'
import { RegisterBanner } from '../static/RegisterBanner'
import { ArticleBanner } from './ArticleBanner'
import { Hidden } from './Hidden'
import style from './Listing.module.sass'
import { ShowMoreButton } from './ShowMoreButton'

type ListingIngredientsProps = {
	ingredients: ItemResult[] | undefined
	totalCount: number
	hasNextPage: boolean
	onNextPage: () => void
}

export const ListingIngredients: FunctionComponent<ListingIngredientsProps> = ({
	ingredients,
	hasNextPage = false,
	totalCount,
	onNextPage,
}) => {
	const auth = useAuth()
	const isSignedUser = auth.status === 'signedIn'

	const translate = useTranslate()

	return (
		<>
			<div className={style.bannerGroup}>
				{ingredients?.map((ingredient, index) => (
					<div
						className={clsx(
							style.cardWrapper,
							!isSignedUser &&
								index === BANNER_INDEX &&
								ingredients.length !== BANNER_INDEX + 1 &&
								style.cardWrapperWithBanner,
						)}
						key={ingredient.id}
					>
						<ArticleBanner
							title={ingredient.name}
							buttonLabel={translate('listingIngredients.button.readMore')}
							lead={ingredient.lead}
							imageUrl={ingredient.image?.url}
							positiveTags={ingredient.positiveForBodyTags}
							negativeTags={ingredient.negativeForBodyTags}
							href={`${InternalLink.Ingredient}${ingredient.slug}`}
						/>

						{!isSignedUser && index === BANNER_INDEX && ingredients.length !== BANNER_INDEX + 1 && (
							<Hidden breakpoint="desktopUp">
								<RegisterBanner />
							</Hidden>
						)}
					</div>
				))}
			</div>
			{hasNextPage && (
				<div className={style.buttonWrapper}>
					<ShowMoreButton handleClick={onNextPage} itemsAmount={totalCount - (ingredients?.length ?? 0)} />
				</div>
			)}
		</>
	)
}
